import store from '@/store';
import prices from '@/store/modules/calculator';

store.registerModule('calculator', prices);

export default store;
